import SupportTicketContainer from "../../../Components/Miscellaneous/SupportTicket/SupportTicketContainer";

const SupportTicket = () => {
  return <SupportTicketContainer />;
};

export default SupportTicket;
